function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.264 2.48c0-1.37 1.09-2.48 2.435-2.48a2.452 2.452 0 012.261 1.552c.113.287.176.6.176.929 0 1.37-1.09 2.48-2.437 2.48-1.344 0-2.435-1.11-2.435-2.48zm5.481 8.905v4.013l1.219-2.996-1.219-1.017zm-6.09 4.013v-4.013l-1.219 1.017 1.219 2.996zm-.242-7.837a1.81 1.81 0 011.458-.74h3.655c.597 0 1.127.292 1.46.74l2.98 4.028.315.447a.627.627 0 01.036.677l-3.315 5.845-.241 11.209H16.08l-1.323-10.753-1.323 10.753h-1.68l-.258-11.032-3.415-6.022a.632.632 0 01.037-.677l.314-.447 2.98-4.028z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "8",
  y: "0",
  width: "14",
  height: "30"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.264 2.48c0-1.37 1.09-2.48 2.435-2.48a2.452 2.452 0 012.261 1.552c.113.287.176.6.176.929 0 1.37-1.09 2.48-2.437 2.48-1.344 0-2.435-1.11-2.435-2.48zm5.481 8.905v4.013l1.219-2.996-1.219-1.017zm-6.09 4.013v-4.013l-1.219 1.017 1.219 2.996zm-.242-7.837a1.81 1.81 0 011.458-.74h3.655c.597 0 1.127.292 1.46.74l2.98 4.028.315.447a.627.627 0 01.036.677l-3.315 5.845-.241 11.209H16.08l-1.323-10.753-1.323 10.753h-1.68l-.258-11.032-3.415-6.022a.632.632 0 01.037-.677l.314-.447 2.98-4.028z",
  fill: "currentColor"
}))));